import styled from "styled-components";
import { lighten } from "polished";
import { Variables } from "../../styles/Variables";

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  /* margin-bottom: 21px; */
  width: 100%;
`;

export const Select = styled.select`
  outline: none;
  padding: 0 16px;
  height: 50px;
  border: 2px solid ${Variables.colorBlack};
  border-radius: 20px;
  font-size: 16px;

  & :hover {
    border: 2px solid ${lighten(0.2, Variables.colorOrange)};
  }

  & :focus {
    border: 2px solid ${Variables.colorOrange};
  }
`;

export const PlaceholderOption = styled.option`
  color: ${Variables.colorGrayIcons};
`;
